<div class="avatar me-1" [ngClass]="classes"><img class="avatar-img img-fluid" [src]="imageSrc" /></div>
